import configcatWrapper from '../ConfigCat/ConfigCatWrapper';

export class FrontendMigrationHandler {
    /**
     * @param {import('../ConfigCat/ConfigCatWrapper').ConfigCatWrapper} configcatwrapper - An instance of the ConfigCatWrapper class
     * */
    constructor(configcatwrapper) {
        this.configcatWrapper = configcatwrapper;
    }

    async redirectUserIfRequired() {
        const shouldRedirectUser = await this.configcatWrapper.shouldUserUseNewFrontend();
        if (!shouldRedirectUser) return;

        const redirectOrigin = await this.configcatWrapper.getFrontendRedirectUrl();
        if (!redirectOrigin || redirectOrigin === window.location.origin) return;

        const isSsoCallback = window.location.pathname === new URL(window.config.SSO_LOGIN_CALLBACK_URL).pathname;
        const destinationPath = isSsoCallback ? '' : `${window.location.pathname}${window.location.search}`;

        window.location.assign(`${redirectOrigin}${destinationPath}`);
    }
}

export default new FrontendMigrationHandler(configcatWrapper);
